import { getFetchedDataPayload, isEmptyArray } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
import { getSitesByIds } from './get-sites-by-ids';
export const getUnselectedSites = () => {
    const allSiteIds = getFetchedDataPayload(browsingDomainStore.data.allSiteIds);
    if (!allSiteIds || isEmptyArray(allSiteIds))
        return undefined;
    const unselectedSiteIds = allSiteIds.filter(siteId => !browsingDomainStore.data.selectedSiteIds.includes(siteId));
    return getSitesByIds(unselectedSiteIds);
};
//# sourceMappingURL=get-unselected-sites.js.map